// extracted by mini-css-extract-plugin
module.exports = {"collection-name":"collection-name-m__collection-name__13N2g"};